var map = {
	"./favicon.ico": "91a0",
	"./logo-2.png": "3e10",
	"./logo-arasana.png": "4fb8",
	"./logo.png": "a4ef",
	"./logo.svg": "ed29",
	"./vuexy-logo.png": "d120"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d47a";